// src/pages/dashboard/userDataUtils.js

/**
 * Fungsi untuk mendapatkan user data dari localStorage berdasarkan user uid
 * @param {string} userUid - UID dari user yang sedang login
 * @returns {Object|null} User data atau null jika tidak ditemukan
 */
export const getUserFromLocalStorage = (userUid) => {
    if (!userUid) return null;

    console.log("Searching localStorage for user with uid:", userUid);

    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        try {
            const item = localStorage.getItem(key);
            if (item) {
                const parsed = JSON.parse(item);

                // Cek struktur 1: {data: {uid: "...", ...}}
                if (parsed.data && parsed.data.uid === userUid) {
                    console.log("Found user in structure 1: {data: {...}}");
                    return parsed.data;
                }

                // Cek struktur 2: langsung {uid: "...", ...}
                if (parsed.uid === userUid) {
                    console.log("Found user in structure 2: {uid: ...}");
                    return parsed;
                }

                // Cek struktur khusus: jika object langsung berisi user data
                if (parsed.email && parsed.uid === userUid) {
                    console.log("Found user in structure 3: direct user object");
                    return parsed;
                }
            }
        } catch (error) {
            continue;
        }
    }

    console.log("User not found in localStorage");
    return null;
};

/**
 * Fungsi untuk mendapatkan nama user dari berbagai sumber
 * @param {Object} user - User object dari useAuthCheck
 * @param {Object} cachedData - User data dari localStorage
 * @returns {string} Nama user
 */
export const getUserName = (user, cachedData) => {
    // Prioritas 1: cachedData.name (dari localStorage)
    if (cachedData?.name && cachedData.name.trim() !== "") {
        return cachedData.name;
    }

    // Prioritas 2: user.name (dari useAuthCheck)
    if (user?.name && user.name.trim() !== "") {
        return user.name;
    }

    // Prioritas 3: cachedData.email username (dari localStorage)
    if (cachedData?.email) {
        return cachedData.email.split("@")[0];
    }

    // Prioritas 4: user.email username (dari useAuthCheck)
    if (user?.email) {
        return user.email.split("@")[0];
    }

    // Fallback
    return "User";
};

/**
 * Fungsi untuk mendapatkan title (Mr./Ms.) berdasarkan gender
 * @param {string} gender - Gender user ('male' atau 'female')
 * @returns {string} Title (Mr. atau Ms.)
 */
export const getUserTitle = (gender) => {
    if (!gender) return "";

    const genderStr = String(gender).trim().toLowerCase();
    if (genderStr === "male") {
        return "Mr.";
    } else if (genderStr === "female") {
        return "Ms.";
    }
    return "";
};